<template>
  <div>
    <div v-if="companyPrograms.length === 0">
      <p class="tw-text-center tw-px-6 tw-py-10">
        Company has no programs.<br />
        If this is a mistake, kindly contact eMentored admin.
      </p>
    </div>

    <template v-else>
      <h4 class="tw-text-center tw-my-5">
        Select Program to login to
      </h4>

      <div class="tw-flex tw-flex-wrap">

        <div v-for="companyProgram in companyPrograms" :key="companyProgram.id" class="tw-w-1/2 tw-p-2 tw-cursor-pointer" @click="selectProgram(companyProgram)">
          <div class="tw-text-center tw-p-4 tw-border tw-rounded-10 transition-fast hover:bg-black-11">
            <img :src="userPhoto(companyProgram.logo)" class="tw-inline-block program-logo tw-mb-5 tw-object-contain" />

            <h4 class="tw-text-app-primary-orange font-title">
              {{ companyProgram.name }}
            </h4>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { apiUrl } from '@/modules/apiHelper';
import { urlFriendly } from '@/modules/dataHelper';

export default {
  name: 'CompanyProgramsLoginOptions',
  props: {
    companyPrograms: {
      type: Array,
      required: true,
    },
  },
  methods: {
    selectProgram(program) {
      this.$emit('program-selected', program);
    },
    userPhoto(url = '') {
      return url.length > 0 ? `${apiUrl}/${urlFriendly(url, true)}` : '';
    },
  },
};
</script>

<style>
.program-logo {
  height: 100px;
}

@media (min-width: 768px) {
  .program-logo {
    height: 200px;
  }
}
</style>
